import Immutable from 'immutable'
import { SET_PARTNER_PROFILE_STATE } from '../actions/setPartnerProfile'

const defaultState = Immutable.fromJS({
  profileIndex: -1,
  hasBeenSet: false
})

export default (s, action) => {
  const state = s || defaultState
  if (action.type === SET_PARTNER_PROFILE_STATE) {
    return state.withMutations((st) => {
      if (action.newProfileIndex !== null) {
        st.set('profileIndex', action.newProfileIndex)
      }
      st.set('hasBeenSet', action.hasBeenSet)
    })
  }
  return state
}

export const getActiveProfileIndex = ({ profileState }) => {
  return {
    profileIndex: profileState.get('profileIndex'),
    hasBeenSet: profileState.get('hasBeenSet')
  }
}
